<div class="admin-id-format-collection-list-wrapper">
  <header>
    <h5>
      {{ 'TRANS__ADMIN__ID_FORMAT__COLLECTION_LIST_HEADING' | translate }}
    </h5>
    <p class="description tone-down-color">
      {{ 'TRANS__ADMIN__ID_FORMAT__COLLECTION_LIST_HINT' | translate }}
    </p>
  </header>

  <section>
    <mat-selection-list
      [multiple]="false"
      (selectionChange)="handleSelectionChange($event.options[0].value)"
      dense
    >
      @for (collection of collections; track $index) {
        <mat-list-option
          [value]="collection"
          [selected]="$index === 0"
          [title]="collection.name + ' (' + collection.count + ')'"
        >
          {{ collection.name }} ({{ collection.count }})
        </mat-list-option>
      }
    </mat-selection-list>
  </section>

</div>
